import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import { StyrBadge } from '../../../connectors/products/StyrBadge';
import SettingsCollection, { ArchiveRestoreMutationTuple } from '../../generic/SettingsCollection';

export default function JobTitlesListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();
	const { t } = useTranslation();

	return (
		<SettingsCollection
			query={graphql.useJobTitlesQuery}
			lazyQuery={graphql.useJobTitlesLazyQuery}
			field="jobTitles"
			translationKey="settings.jobTitles"
			title={(title: graphql.JobTitle) => localize(title.title).text}
			link={(title) => `/settings/jobs/titles/${title.id}`}
			titleBadge={(jobTitle: graphql.JobTitle) =>
				jobTitle.styrData?.jobID ? (
					<StyrBadge
						tooltip={
							jobTitle.styrData.jobName
								? t('settings.connectors.styr.badge.linkedTo', {
										name: jobTitle.styrData.jobName,
									})
								: undefined
						}
					/>
				) : null
			}
			variables={{}}
			archive={graphql.useArchiveJobTitleMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreJobTitleMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/jobs/titles/new')}
		/>
	);
}
